export default __webpack_public_path__ + "static/media/MASCOT DISDIK 2-01.b118d65d.png";